"use strict";
/*
 * Created on 09 19 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var CompetitorConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorConverter, _DataObjectConverter_);

  function CompetitorConverter() {
    _classCallCheck(this, CompetitorConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorConverter).apply(this, arguments));
  }

  return CompetitorConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorConverter = CompetitorConverter;